import React, { useState, useEffect } from 'react';
import { colors } from '../styles/colors';
import { fonts, fontWeights } from '../styles/fonts';
import { content } from '../constants/content';

function EMPDefense() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const images = ['/electric.png', '/military.png'];
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return (
    <section style={isMobile ? styles.sectionMobile : styles.section}>
      <h2 style={isMobile ? styles.titleMobile : styles.title}>
        {content.empDefense.title}
      </h2>
      
      <p style={isMobile ? styles.subtitleMobile : styles.subtitle}>
        {content.empDefense.subtitle}
      </p>
      
      <div style={isMobile ? styles.comparisonGridMobile : styles.comparisonGrid}>
        {content.empDefense.comparison.map((item, index) => (
          <div key={index} style={isMobile ? styles.comparisonCardMobile : styles.comparisonCard}>
            <div style={isMobile ? styles.imageContainerMobile : styles.imageContainer}>
              <img 
                src={images[index]} 
                alt={item.title}
                style={styles.image}
              />
            </div>
            <h3 style={isMobile ? styles.comparisonTitleMobile : styles.comparisonTitle}>
              {item.title}
            </h3>
            <p style={isMobile ? styles.comparisonDescriptionMobile : styles.comparisonDescription}>
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}

const styles = {
  section: {
    padding: '80px 60px',
    backgroundColor: '#F8F9FA',
    textAlign: 'center',
  },
  sectionMobile: {
    padding: '40px 20px',
    backgroundColor: '#F8F9FA',
    textAlign: 'center',
  },
  title: {
    fontSize: '48px',
    fontWeight: fontWeights.bold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '30px',
  },
  titleMobile: {
    fontSize: '32px',
    fontWeight: fontWeights.bold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '20px',
    lineHeight: '1.2',
  },
  subtitle: {
    fontSize: '18px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    maxWidth: '950px',
    margin: '0 auto 60px auto',
    lineHeight: '1.6',
  },
  subtitleMobile: {
    fontSize: '16px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    maxWidth: '100%',
    margin: '0 auto 40px auto',
    lineHeight: '1.6',
    padding: '0 10px',
  },
  comparisonGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '30px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  comparisonGridMobile: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    maxWidth: '100%',
    margin: '0 auto',
  },
  comparisonCard: {
    padding: '50px 40px',
    backgroundColor: colors.white,
    border: `2px solid ${colors.primary}`,
    borderRadius: '12px',
    textAlign: 'center',
  },
  comparisonCardMobile: {
    padding: '30px 20px',
    backgroundColor: colors.white,
    border: `2px solid ${colors.primary}`,
    borderRadius: '12px',
    textAlign: 'center',
    width: '100%',
  },
  imageContainer: {
    width: '100%',
    height: '200px',
    marginBottom: '30px',
    overflow: 'hidden',
    borderRadius: '8px',
  },
  imageContainerMobile: {
    width: '100%',
    height: '150px',
    marginBottom: '20px',
    overflow: 'hidden',
    borderRadius: '8px',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  comparisonTitle: {
    fontSize: '24px',
    fontWeight: fontWeights.semibold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '20px',
  },
  comparisonTitleMobile: {
    fontSize: '22px',
    fontWeight: fontWeights.semibold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '15px',
  },
  comparisonDescription: {
    fontSize: '16px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    lineHeight: '1.6',
  },
  comparisonDescriptionMobile: {
    fontSize: '15px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    lineHeight: '1.5',
  },
};

export default EMPDefense;